// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PColumnWidthOutlinedSvg from "@fishx/icons-svg/es/asn/PColumnWidthOutlined";
import FishxIcon from '../components/FishxIcon';

var PColumnWidthOutlined = function PColumnWidthOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PColumnWidthOutlinedSvg
  }));
};

PColumnWidthOutlined.displayName = 'PColumnWidthOutlined';
export default React.forwardRef(PColumnWidthOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PColumnWidthOutlined.js
// module id = 3297
// module chunks = 0